import { render, staticRenderFns } from "./MaaSBox.vue?vue&type=template&id=f55b1a9e&scoped=true"
import script from "./MaaSBox.vue?vue&type=script&lang=js"
export * from "./MaaSBox.vue?vue&type=script&lang=js"
import style0 from "./MaaSBox.vue?vue&type=style&index=0&id=f55b1a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55b1a9e",
  null
  
)

export default component.exports